import useCurrentCustomerStore from "stores/CustomerStore";
import { useFromUser } from "stores/LocalStorageHelper";
import { encrypt } from "../utils/crypto";

export const useBuildCustomer = () => {
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");

	const {
		ID,
		firstName,
		middleName,
		lastName,
		gender,
		generation,
		age,
		cellPhone,
		SSN,
		birthDate,
		email,
		extraPhone,
		homePhone,
		workPhone,
		license,
		licExpires,
		licState,
		street,
		unit,
		city,
		state,
		zip,
		county,
		fromDate,
		toDate,
		notes,
		creditScore,
		creditScoreEfx,
		creditScoreXpn,
		source,
		mailRecNum,
		customerNumber,
		llCity,
		llName,
		llPhone,
		llState,
		llStreet,
		llUnit,
		llZip,
		customerStatus,
		originalID,
		status,
		military,
		type,
		licType,
		licCountry,
		uploadCode,
		createdOn,
	} = useCurrentCustomerStore();
	// Customer information stored and retrieved from the store
	const customer = {
		ID,
		firstName,
		middleName,
		lastName,
		gender,
		generation,
		age,
		cellPhone,
		SSN: encrypt(SSN),
		birthDate,
		email,
		extraPhone,
		homePhone,
		workPhone,
		license,
		licExpires,
		licState,
		street,
		unit,
		city,
		state,
		zip,
		county,
		fromDate,
		toDate,
		dealerID,
		locationID,
		notes: Array.isArray(notes) ? JSON.stringify(notes) : "[]",
		creditScore,
		creditScoreEfx,
		creditScoreXpn,
		source,
		mailRecNum,
		customerNumber,
		llCity,
		llName,
		llPhone,
		llState,
		llStreet,
		llUnit,
		llZip,
		customerStatus,
		originalID,
		status,
		military,
		type,
		licType,
		licCountry,
		uploadCode,
		createdOn,
	};

	return customer;
};

export default useBuildCustomer;
